<template>
  <div class="lunarFullCalendar clearfix">
    <div class="full-calendar">
      <lunar-full-calendar
        :events="eventService"
        ref="calendar"
        @event-selected="eventSelected"
        :config="config"
        @day-click="dayClick"
      >
      </lunar-full-calendar>
    </div>
    <div class="oldmanvirthdayright">
      <div class="oldmanvirthdayright-top">
        <div class="oDate">{{oDate}}{{weekDay}}</div>
        <div class="fz">{{toDate}}</div>
        <div class="lunarCalendar">{{lunarCalendar}}</div>
        <div class="lunarCalendar">{{almanac}}</div>
        <div class="lunarCalendar">{{animal}}</div>
      </div>
      <div class="oldmanvirthdayright-bottom">
        <div class="toBirth">今日过生日老人</div>
        <div class="oldName">
          <div class="oldName-a" v-for="(item,index) in oldNameList" :key="index">{{item.oldName}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { LunarFullCalendar } from "vue-lunar-full-calendar";
import util from "@/utils/util.js";
export default {
  name: "OldmanBirthday",
  data: function() {
    let self = this;
    return {
      flag:-1,
      oldNameList:[],//每日过生日的老人
      year:"",//处理数据的时候会用到年
      month:"",//接口调用的参数
      date:"",//接口调用的参数
      oDate: "",
      toDate: "",
      lunarCalendar: "",
      almanac: "",
      animal: "",
      weekDay:"",//星期
      eventService: [
      ],
      
      config: {
        // lunarCalendar
        // Control whether the Chinese calendar shows true, unrealistic flase, default true.（lunarCalendar控制是否显示中国农历、显示的为true，隐藏为flase，默认为true）
        lunarCalendar: true,
        height: "parent",
        locale: "zh-cn",
        eventColor: 'white',
        buttonText: {
          today: "今天",
          month: "月",
          week: "周",
          day: "日"
        },
        header: {
          left: "prev,next, today",
          center: "title",
          right: "hide, custom"
        },
        // eventOrder:'index',   // 这个是控制事件排序的功能，意思是 按照字段 事件数据中index来排序
        // eventLimitClick: 'day', //点击今天日列表图
        eventLimit: true, // 一天中显示多少条事件，多了隐藏
        firstDay: 1, // 控制周一周日那个在前面
        defaultView: "month",
        allDaySlot: true, // agenda视图下是否显示all-day
        allDayText: "全天", // agenda视图下all-day的显示文本
        timezone: "local", // 时区默认本地的
        slotLabelFormat: "HH:mm", // 周视图和日视同的左侧时间显示
        viewRender(view, element) {
          self.viewRender(view, element);
        },
        // 配置标题年月格式展示
        views: {
          month: {
              titleFormat: 'YYYY年MM月'
          },
        },
        customButtons: {
          // 新增按钮
          hide: {
            text: "隐藏农历",
            click: function() {
              self.$refs.calendar.fireMethod("option", {
                lunarCalendar: false
              });
              self.$refs.calendar.fireMethod("option", {
                header: {
                  left: "prev,next, today",
                  center: "title",
                  right: "show, custom, month,agendaWeek,agendaDay"
                }
              });
            }
          },
          show: {
            text: "显示农历",
            click: function() {
              self.$refs.calendar.fireMethod("option", {
                lunarCalendar: true
              });
              self.$refs.calendar.fireMethod("option", {
                header: {
                  left: "prev,next, today",
                  center: "title",
                  right: "hide, custom, month,agendaWeek,agendaDay"
                }
              });
            }
          }
        }
      }
    };
  },
  components: {
    LunarFullCalendar
  },
  methods: {
    // 注释的是功能是可以修改对应的功能值属性，比如设置  eventLimit为 false
    //  this.$refs.calendar.fireMethod('option',{
    //      eventLimit :false
    //  })
    /* 
      点击天获取数据
    */
    dayClick(date, jsEvent, view) {
      // 点击当天的事件
      //alert('农历数据：' + JSON.stringify(window.lunar(date._d)))
      console.log(date, jsEvent, "dayClick");
      let calendarObj = window.lunar(date._d);
      console.log(calendarObj,"========")
      this.oDate = util.formatDate.format(
        new Date(calendarObj.oDate),
        "yyyy-MM-dd"
      );
      this.weekDay='星期'+calendarObj.cnDay;
      this.toDate = util.formatDate.format(new Date(calendarObj.oDate), "dd");
      let lMonth = calendarObj.lMonth;
      let lDate = calendarObj.lDate;
      this.lunarCalendar = "农历" + lMonth + "月" + lDate;
      let gzYear = calendarObj.gzYear;
      let gzMonth = calendarObj.gzMonth;
      let gzDate = calendarObj.gzDate;
      this.almanac = gzYear + "年" + gzMonth + "月" + gzMonth + "日";
      let animal = calendarObj.animal;
      this.animal = animal + "年";
      console.log(this.oDate,"this.oDate--------");
      this.month = this.oDate.split('-')[1];
      this.date = this.oDate.split('-')[1]+'-'+this.oDate.split('-')[2];
      this.selectByMonth();
      this.showAllOldMan();
    },

    eventSelected(event, jsEvent, view) {
      // 选中事件
    },

    /* 
      渲染数据
    */
    viewRender(view, element) {
      //by guo 2019-09-27 10:28 注释掉
      // var preDate = new Date(view.calendar.currentDate._d.getTime() - 24*60*60*1000); //前一天
      var preDate = new Date(view.calendar.currentDate._d.getTime() - 8*60*60*1000); //前8小时    插件有八个小时的时差  需要减去8小时
      var calendarObj = '';
      //by guo 2019-09-27 10:28 注释掉
      // if(this.flag==-1){
      //   calendarObj = window.lunar(new Date(preDate));
      // }else{
      //   calendarObj = window.lunar(new Date(view.calendar.currentDate._d));
      // }
      calendarObj = window.lunar(new Date(preDate));
      this.oDate = util.formatDate.format(
        new Date(calendarObj.oDate),
        //new Date(preDate),
        "yyyy-MM-dd"
      );
      this.weekDay='星期'+calendarObj.cnDay;
      //this.toDate = util.formatDate.format(new Date(preDate), "dd");//by guo 2019-09-27 10：28 注释掉
      this.toDate = util.formatDate.format(new Date(calendarObj.oDate), "dd");
      let lMonth = calendarObj.lMonth;
      let lDate = calendarObj.lDate;
      this.lunarCalendar = "农历" + lMonth + "月" + lDate;
      let gzYear = calendarObj.gzYear;
      let gzMonth = calendarObj.gzMonth;
      let gzDate = calendarObj.gzDate;
      this.almanac = gzYear + "年" + gzMonth + "月" + gzMonth + "日";
      let animal = calendarObj.animal;
      this.animal = animal + "年";
      this.year= this.oDate.split('-')[0];
      this.month = this.oDate.split('-')[1];
      this.date = this.oDate.split('-')[1]+'-'+this.oDate.split('-')[2];
      this.selectByMonth();
      this.showAllOldMan();
      this.flag=2;
    },

    /* 
      根据月份查询过生日的老人
    */
    selectByMonth() {
      let params = new Object();
      params.month = this.month;
      this.$postForm("omc/Oldman/selectByMonth", params).then(
        res => {
          console.log(res);
          let eventService=[];
          res.result.forEach(item=>{
            let birthOldman=new Object();
            birthOldman.id=item.oldManId;
            // birthOldman.title=item.oldName+item.number;
            birthOldman.title=item.number;
            birthOldman.allDay=true;
            birthOldman.date = item.birthday.substring(5,10);
            var birthdayList=item.birthday.split('-');
            console.log(birthdayList,"birthdayList");
            var birthday=this.year+'-'+birthdayList[1]+'-'+birthdayList[2];
            birthOldman.start=new Date(birthday);
            birthOldman.end=new Date(birthday);
            eventService.push(birthOldman);
          })
          this.$nextTick(()=>{
            // setTimeout(()=>{
              // let parent = document.getElementsByClassName('fc-title');
              let fcday = document.getElementsByClassName('fc-day');
              for(let i=0;i<fcday.length;i++){
                if(fcday[i].childNodes){
                  if(fcday[i].children[0]!=undefined){
                    fcday[i].removeChild(fcday[i].lastChild);
                  }
                }
              }
              for(let i=0;i<fcday.length;i++){
                let date = fcday[i].getAttribute('data-date').substring(5,10);
                fcday[i].style="padding-top:30px";
                eventService.forEach(itemss =>{
                  if(itemss.date == date){
                      var oImgBox = document.createElement("img");
                      oImgBox.setAttribute("id", "imgBox");
                      oImgBox.setAttribute("src", require("@/assets/beadhouse/oldbirthday.png"));
                      oImgBox.setAttribute("alt", "birthday");
                      oImgBox.style = "font-size:100px;opacity:1;width:30px;height:30px;vertical-align:middle";
                      fcday[i].appendChild(oImgBox);
                  }
                })
              }
              //如果子节点存在 先移除子节点
              // console.log(parent,"--------")
              // for(let i=0;i<parent.length;i++){
              //   if(parent[i].childNodes){
              //     console.log(parent[i].children[0],"=====")
              //     if(parent[i].children[0]!=undefined){
              //       parent[i].removeChild(parent[i].lastChild);
              //     }
              //   }
              // }
              // console.log(parent,"999999")
              // for(let i=0;i<parent.length;i++){
              //   var oImgBox = document.createElement("img");
              //   oImgBox.setAttribute("id", "imgBox");
              //   oImgBox.setAttribute("src", require("@/assets/beadhouse/oldbirthday.png"));
              //   oImgBox.setAttribute("alt", "图片一");
              //   oImgBox.style = "font-size:100px;opacity:1;width:30px;height:30px;vertical-align:middle";
              //   parent[i].appendChild(oImgBox);
              // }
            // },0)
          })
        } 
      );
    },

    /* 
      根据日查询过生日的老人
    */
    showAllOldMan() {
      let params = new Object();
      params.date = this.date;
      this.oldNameList=[];
      this.$postForm("omc/Oldman/showAllOldMan", params).then(
        res => {
          console.log(res);
          this.oldNameList=res.result;
          console.log(this.oldNameList);
        }
      );
    }
  },
 
  mounted() {

  }
};
</script>
<style scoped lang="scss">
$color: #E4480F;
.lunarFullCalendar {
  min-width: 900px;
  height: 100%;
  background: #fff;
  .top {
    height: 100px;
    h2 {
      text-align: center;
      font-size: 15px;
    }
    div {
      font-size: 13px;
    }
  }
  .oldmanvirthdayright {
    float: right;
    width: 16%;
    .oldmanvirthdayright-top {
      height: 300px;
      background: #E4480F;
    }
    .oldmanvirthdayright-bottom {
      height: 250px;
      border: 1px solid #ccc;
      .toBirth {
        background: #E4480F;
        width: 80%;
        height: 40px;
        line-height: 40px;
        margin: 20px auto 0px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        font-weight: 500;
      }
    }
  }
  .full-calendar {
    width: 80%;
    float: left;
    padding: 20px;
    height: 98%;
      .fc-unthemed thead{
        border-color: #eaecf1;
        text-align: center;
        font-size: 18px;
      }
      .fc-unthemed .fc-content{
        border-color: #eaecf1;
        text-align: center;
        font-size: 18px;
      }
      .fc-unthemed th{
        border-color: #eaecf1;
        text-align: center;
        font-size: 18px;
      }
      .fc-unthemed td{
        border-color: #eaecf1;
        text-align: center;
        font-size: 18px;
      }
      .fc-unthemed tbody{
        border-color: #eaecf1;
        text-align: center;
        font-size: 18px;
      }
      .fc-unthemed .fc-row{
        border-color: #eaecf1;
        text-align: center;
        font-size: 18px;
      }
      .fc-unthemed .fc-list-view{
        border-color: #eaecf1;
        text-align: center;
        font-size: 18px;
      }
      .fc-unthemed .fc-popover{
        border-color: #eaecf1;
        text-align: center;
        font-size: 18px;
      }
      .fc-unthemed .fc-divider{
        border-color: #eaecf1;
        text-align: center;
        font-size: 18px;
      }
      .fc-unthemed .fc-list-heading td {
        border-color: #eaecf1;
        text-align: center;
        font-size: 18px;
      }
      .fc-header-toolbar {
        height: 30px;
        margin-bottom: 0;
        line-height: 30px;
        h2 {
          font-size: 24px;
          color: #000;
        }
      }
      .fc-button {
        height: 30px;
        background: #fff;
        border-color: #fff;
        box-shadow: none;
        padding: 0;
      }
      .fc-today-button {
        font-size: 15px;
        color: $color;
      }
      .fc-show-button{
        position: relative;
        width: 80px;
        border: 1px solid #bbbfcd;
        border-radius: 20px;
        font-size: 15px;
        color: #000;
      }
      .fc-hide-button {
        position: relative;
        width: 80px;
        border: 1px solid #bbbfcd;
        border-radius: 20px;
        font-size: 15px;
        color: #000;
      }
      .fc-next-button,
      .fc-prev-button {
        color: #7d8292;
      }
      .fc-button-group {
        margin-left: 20px;
        font-size: 15px;
        button {
          width: 80px;
          color: #000;
          border: 1px solid #bbbfcd;
        }
        button:first-child {
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
        }
        button:last-child {
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
        }
        .fc-state-active {
          background: $color;
          color: #fff;
          text-shadow: none;
        }
      }
      
      td{
        cursor: pointer !important;
      }
      .fc-agendaDay-view,
      .fc-month-view,
      .fc-agendaWeek-view {
        .fc-widget-content {
          .fc-sun,
          .fc-sat {
            background: rgba(245, 246, 248, 0.6);
          }
          .fc-day-number {
            font-size: 15px;
            letter-spacing: 0;
            line-height: 13px;
            float: left;
          }
          .fc-day-top {
            padding: 15px 12px 0 12px;
          }
          .fc-day-cnTerm,
          .fc-day-cnDate {
            font-size: 12px;
            color: #7d8292;
            float: right;
          }
          .fc-more {
            font-size: 12px;
            color: #7d8292;
          }
          .fc-event {
            cursor: pointer;
            font-size: 12px;
            color: #000;
            background-color: rgba($color: $color, $alpha: 0.15) !important;
            border: 1px solid rgba($color: $color, $alpha: 0.15) !important;
            border-left: 2px solid rgba($color: $color, $alpha: 0.15) !important;
            border-radius: 0;
          }
          .fc-day-grid-event {
            padding: 1px 0 1px 5px;
            background-color: #E4480F !important;
            z-index: -1;
          }
        }
      }
      .fc-agendaWeek-view,
      .fc-agendaDay-view {
        .fc-axis {
          font-size: 15px;
        }
        .fc-title {
          font-size: 15px;
          color: $color;
        }
      }
      .fc-month-view {
        .fc-event {
          color:#fff !important;
          &.fc-not-start {
            border-left: 1px solid rgba($color: $color, $alpha: 0.1) !important;
          }
        }
      }
      .fc-agendaDay-view {
        .fc-head {
          table {
            margin: 15px 0;
          }
          .fc-day-header {
            display: none;
          }
        }
      }
      .fc-head {
        .fc-day-header,
        .fc-widget-header,
        .fc-head-container {
          border-top-color: #fff;
          border-left-color: #fff;
          border-right-color: #fff;
        }
        table {
          margin: 10px 0 15px 0;
          font-size: 15px;
          color: #000;
        }
      }
  }
  .oldName{
    width:80%;
    height:150px;
    margin:0 auto;
    overflow-y:auto;
  }
  .oldName-a{
    height:25px;
    line-height: 25px;
    border: 1px solid #ccc;
    text-align: center;
    font-size: 16px;
    font-weight:500;
    color:rgb(14, 13, 13);
  }
}
.tip {
  color: $color;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}
.clearfix {
  *zoom: 1;
}
.oDate {
  // font-size: 25px;
  font-size: 1.5vw; // by yhw 20210705 修改 字体大小为25px,页面会乱掉
  color: #fff;
  text-align: center;
  height: 70px;
  line-height: 70px;
}
.fz {
  // font-size: 80px;
  font-size: 5vw;
  color: #fff;
  text-align: center;
}
.lunarCalendar {
  // font-size: 20px;
  font-size: 1.3vw;
  color: #fff;
  text-align: center;
}

</style>

